import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';

import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Text} from '@/src/ui';

import css from '../styles/MultipleSearchField.module.css';

const MultipleSearchField = ({searchValue, onSearchValueChange}) => {
  const {t} = useTranslation(TextLocal.LOCALE_SOURCE.COMMON);

  return (
    <div className={css.searchField}>
      <div className={css.title}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_32}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
          fontFamily={Text.FONT_FAMILY.RUBIK}
          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_4}
          tagComponent={Text.TAG.H1}
        >
          <TextLocal id={'search.searchPlaceholder'} />
        </Text>
      </div>
      <div className={css.inputBlock}>
        <input
          type="search"
          placeholder={t('search.searchPlaceholder')}
          className={css.searchInput}
          value={searchValue}
          onChange={onSearchValueChange}
        />
      </div>
    </div>
  );
};

MultipleSearchField.propTypes = {
  searchValue: PropTypes.string.isRequired,
  onSearchValueChange: PropTypes.func.isRequired,
};

export default MultipleSearchField;
